import * as React from "react"
const Pork = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}>
    <path
      fill="#EB7A3B"
      stroke="#010101"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M14.933 16.247c-1.304 1.304-3.938 2.505-6.454 3.435-2.619.968-3.54 4.397-1.566 6.371.867.867 2.115 1.233 3.277.84 2.337-.79 6.406-2.518 9.638-5.75 3.232-3.233 4.961-7.302 5.751-9.64.393-1.16.027-2.409-.84-3.276-1.974-1.974-5.403-1.052-6.371 1.566-.93 2.516-2.132 5.15-3.435 6.454Z"
    />
    <path
      stroke="#010101"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M14.034 21.715c-.716-1.14-.981-1.406-2.121-2.122M17.87 19.184c-.716-1.14-.981-1.405-2.121-2.121M20.4 15.348c-.715-1.14-.98-1.405-2.12-2.12"
    />
    <path
      fill="#EB7A3B"
      stroke="#010101"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m23.698 1.963.61 4.993 4.567-1.961-5.177-3.032ZM4.374 30.374l1.96-4.567-4.992-.61 3.032 5.177Z"
    />
  </svg>
)
export default Pork
